<script setup>
</script>
    
<template>
  <NuxtLayout>
    <NuxtPage />
  </NuxtLayout>
</template>

